import { Pipe, PipeTransform } from '@angular/core';
import {
  PaymentMethodEnum,
  PaymentMethodSymbol,
} from '@qaroni-core/types/payments/payment-method.enum';

@Pipe({
  name: 'paymentMethodSymbol',
  standalone: false,
})
export class PaymentMethodSymbolPipe implements PipeTransform {
  transform(value: PaymentMethodEnum | string): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(PaymentMethodSymbol, value)
    ) {
      return PaymentMethodSymbol[value];
    }

    return value;
  }
}
